import Webpush from '../pages/profile/webpush/Webpush.vue';
import Footer from './components/footer/Footer.vue';
import Drawer from './components/drawer/Drawer.vue';
import Header from './components/header/Header.vue';
import Loader from './components/loader/Loader.vue';

export default {
  components: {
    Drawer,
    Header,
    Webpush,
    Footer,
    Loader,
  },
  computed: {
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    isBlocked() { return !!(this.$store.getters.isBlocked); },
    onModeration() { return !!(this.$store.getters.onModeration); },
    isApproved() { return !!(this.$store.getters.isApproved); },
    user() { return this.$store.state.user; },
    extranet() { return this.$store.state.settings.extranet === true; },
    isManager() { return this.$store.getters.isManager; },
    isDealer() { return this.$store.getters.isDealer; },
    loading() { return this.$store.state.loading; },
    epsCartLength() { return this.$store.state.eps.cartLength; },
    layout() { return this.$store.state.settings.layout; },
    bgUrl() { return this.$store.state.settings.bgUrl; },
    showWebpushPopup() {
      return 'Notification' in window
        && this.$store.state.user
        && this.$store.state.settings.webpush === true
        && this.$store.state.webpush.webpushPopupOpened === true
        && this.$store.state.webpush.webpushFirebaseToken === null
        && this.$store.state.webpush.webpushDeclinedAt === null;
    },
    news() { return this.$store.state.settings.news === true; },
    unreadNewsCount() { return this.$store.state.news.unreadNewsCount; },
    unreadCoursesCount() { return this.$store.state.courses.unreadCoursesCount; },
    instructions() { return this.$store.state.settings.instructions === true; },
    sales() { return this.$store.state.settings.sales === true; },
    courses() { return this.$store.state.settings.courses === true; },
    tickets() { return this.$store.state.settings.module_tickets === true; },
    isBannersOn() { return this.$store.state.settings.module_banners === true; },
    isShopOn() {
      return this.user
        && this.user.role_settings.modules_prizes_shop
        && this.$store.state.settings.shop === true;
    },
    showPrizes() {
      return this.user
        && this.user.show_prizes
        && this.user.role_settings.property_can_spend_bonuses;
    },
    showOrders() { return this.user && this.user.role_settings.property_can_spend_bonuses; },
    /** Верхнее меню */
    topMenuItems() {
      const menu = [];
      if (this.isAuthenticated) {
        this.isApproved && menu.push({ title: 'Профиль', path: '/profile', icon: 'user-circle', showIcon: true, showTitle: true });
        this.isApproved && this.showPrizes && menu.push({ title: 'Призы', path: '/prizes', icon: 'gift', showIcon: true, showTitle: true });
        this.isApproved && this.showOrders && menu.push({ title: 'Заказы', path: '/orders', icon: 'file-alt', showIcon: true, showTitle: true });
        menu.push({ title: 'Опросы', path: '/surveys', icon: 'list-ol', showIcon: true, showTitle: true });
        this.isApproved && menu.push({ title: 'Полезное', path: '/instructions', icon: 'newspaper', showIcon: true, showTitle: true });
        this.isApproved && this.sales && menu.push({ title: 'Продажи', path: '/actions', icon: 'ruble-sign', showIcon: true, showTitle: true });
        menu.push({ title: 'Правила', path: '/rules', icon: 'scroll', showIcon: true, showTitle: true });
      }
      return menu;
    },
    /** Левое мобильное меню в дровере */
    leftMenuItems() {
      const menu = [];
      if (this.isAuthenticated) {
        this.isApproved && menu.push({ title: 'Профиль', path: '/profile', icon: 'user-circle' });
        this.isApproved && this.showPrizes && menu.push({ title: 'Призы', path: '/prizes', icon: 'gift' });
        this.isApproved && menu.push({ title: 'Заказы', path: '/orders', icon: 'file-alt' });
        menu.push({ title: 'Опросы', path: '/surveys', icon: 'list-ol', showIcon: true, showTitle: true });

        this.isApproved && this.isShopOn && menu.push({ title: 'Товары', path: '/shop', icon: 'shopping-cart' });
        this.isApproved && menu.push({ title: 'Полезное', path: '/instructions', icon: 'newspaper', optionalClass: 'long-title' });
        this.isApproved && this.sales && menu.push({ title: 'Продажи', path: '/actions', icon: 'ruble-sign' });
        menu.push({ title: 'Правила', path: '/rules', icon: 'scroll', showIcon: true, showTitle: true });
        this.tickets
          ? menu.push({ title: 'Помощь', path: '/tickets', icon: 'question-circle' })
          : menu.push({ title: 'Помощь', path: '/feedback', icon: 'question-circle' });
        !this.isBlocked && menu.push({ title: 'Статус', path: '/status', icon: 'trophy', showIcon: true, showTitle: true });
      } else {
        menu.push({ title: 'Главная страница', path: '/', icon: 'home' });
        menu.push({ title: 'Помощь', path: '/feedback', icon: 'question-circle' });
        menu.push({ title: 'Войти', path: '/', icon: 'sign-in-alt' });
      }
      if (this.extranet) {
        return [];
      }
      return menu;
    },
  },
  methods: {
    /** Разлогин пользователя */
    UserLogout() {
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
    /** получение данных для авторизованного пользователя */
    async GetUserData() {
      await this.$store.dispatch('surveys/GetSurveysList', {
        profile_id: this.user.profile_id,
        period_id: null,
      });
      await this.$store.dispatch('news/GetUnreadNewsCount', this.user.profile_id);
      await this.$store.dispatch('courses/GetUnreadCoursesCount', this.user.profile_id);
    },
  },
  watch: {
    user(val) { val && this.GetUserData(); },
  },
  created() {
    this.$store.dispatch('GetSettings');
    this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
  },
};
